(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/init.js'); "use strict";

(function (svs) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.type = svs.components.dialog.type || {};
  svs.components.dialog.keyEvent = svs.components.dialog.keyEvent || {};
  svs.components.dialog.message = svs.components.dialog.message || {};
  svs.components.dialog.message.align = svs.components.dialog.message.align || {};
  svs.components.dialog.priority = svs.components.dialog.priority || {};
  svs.components.dialog.branding = svs.components.dialog.branding || {};
  svs.components.dialog.autoClose = svs.components.dialog.autoClose || {};
  svs.components.dialog.handshakeTimeout = svs.components.dialog.handshakeTimeout || {};
  svs.components.dialog.button = svs.components.dialog.button || {};
  svs.components.dialog.type.DEFAULT = 'confirm';
  svs.components.dialog.type.CONFIRM = 'confirm';
  svs.components.dialog.type.ERROR = 'error';
  svs.components.dialog.branding.TUR = 'tur';
  svs.components.dialog.branding.SPORT = 'sport';
  svs.components.dialog.branding.NEUTRAL = 'neutral';
  svs.components.dialog.branding.ERROR = 'error';
  svs.components.dialog.autoClose.SHORT = 3000;
  svs.components.dialog.autoClose.MEDIUM = 5000;
  svs.components.dialog.autoClose.LONG = 10000;
  svs.components.dialog.autoClose.VERY_LONG = 20000;
  svs.components.dialog.autoClose.DEFAULT = svs.components.dialog.autoClose.LONG;
  svs.components.dialog.handshakeTimeout.DEFAULT = 10000;
  svs.components.dialog.message.TEXT = 'text';
  svs.components.dialog.message.HREF = 'link';
  svs.components.dialog.message.CHECKBOX = 'checkbox';
  svs.components.dialog.message.align.LEFT = 'align-left';
  svs.components.dialog.message.align.CENTER = 'align-center';
  svs.components.dialog.message.align.RIGHT = 'align-right';
  svs.components.dialog.button.PRIMARY = 'primary';
  svs.components.dialog.button.SECONDARY = 'secondary';
  svs.components.dialog.api = new svs.components.dialog.Dialog(); 
})(svs);
 })(window);